import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import className from 'classnames'
import analyticsUtils from '../../helpers/analytics-utils'
import { rangesForDate } from '../../helpers/time-ranges'
import { getNowInCentreInDateFormat } from '../../helpers/date-helpers'
import FilterItem from './filter-item'
import styles from './index.module.scss'

const trackWhatsOnFilter = filter =>
  analyticsUtils.gaTagTracking({
    event: analyticsUtils.events.WHATS_ON_FILTERS,
    details: {
      filter,
      page: analyticsUtils.categories.WHATS_HAPPENING_FEATURED,
    },
  })

const WhatsOnFilters = ({
  onClick,
  handleFilters,
  selectedFilter,
  centre,
  navigatable,
  classNames,
}) => {
  const ranges = rangesForDate(
    getNowInCentreInDateFormat(centre.timeZone),
    selectedFilter
  )
  return (
    <Fragment>
      {ranges.map((entry, index) => {
        const isSelected = selectedFilter === entry.slug()
        return (
          <FilterItem
            entry={entry}
            centre={centre}
            navigatable={navigatable}
            key={index}
            id={`${entry.slug()}-filter`}
            className={className(classNames, styles.navItem, {
              [styles.active]: isSelected,
            })}
            isSelected={isSelected}
            onClick={() => {
              if (onClick) {
                onClick(entry)
              }
              if (handleFilters) {
                handleFilters(entry.slug())
              }
              trackWhatsOnFilter(entry.name)
            }}
          >
            {entry.name}
          </FilterItem>
        )
      })}
    </Fragment>
  )
}

WhatsOnFilters.propTypes = {
  handleFilters: PropTypes.func,
  onClick: PropTypes.func,
  selectedFilter: PropTypes.string,
  navigatable: PropTypes.bool,
  centre: PropTypes.object,
  classNames: PropTypes.string,
}

WhatsOnFilters.defaultProps = {
  navigatable: false,
}

export default WhatsOnFilters
